var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vertical-drag", class: { summary: _vm.summary } },
    [
      !_vm.summary
        ? _c("div", { staticClass: "cont-tit" }, [
            _c("h6", [_vm._v(_vm._s(_vm.currentBranch.name))])
          ])
        : _vm._e(),
      _c("div", { staticClass: "address" }, [
        !_vm.summary
          ? _c("div", { staticClass: "tit" }, [
              _c("i", { staticClass: "icon icon-location" }),
              _vm._v(" " + _vm._s(_vm.$t("MHLP-04-01-02-04")))
            ])
          : _vm._e(),
        _vm._v(" " + _vm._s(_vm.currentBranch.address) + " ")
      ]),
      !_vm.summary
        ? _c("div", { staticClass: "tel" }, [
            _c("div", { staticClass: "tit" }, [
              _c("i", { staticClass: "icon icon-location-call" }),
              _vm._v(" " + _vm._s(_vm.$t("MHLP-04-01-02-05")))
            ]),
            _vm._v(" " + _vm._s(_vm.currentBranch.telephone) + " ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }